// Which layout the page uses. A phone in portrait gets the compact layout:
// the cue bar, the board, and a tray of tabs, all on one screen.

import { COMPACT_LAYOUT_QUERY } from '../constants';
import { createStore } from '../lib/store';

export type LayoutMode = 'wide' | 'compact';

const query = window.matchMedia(COMPACT_LAYOUT_QUERY);

const modeFor = (isCompact: boolean): LayoutMode => (isCompact ? 'compact' : 'wide');

export const layoutStore = createStore<LayoutMode>(modeFor(query.matches));

/** Call once at startup. */
export const startLayout = (): void => {
  query.addEventListener('change', (event) => layoutStore.set(modeFor(event.matches)));
};

const PICK_VERBS: Record<LayoutMode, string> = { wide: 'Click', compact: 'Tap' };

/** The word for a pick in an instruction: a click with a pointer, a tap on a touch screen. */
export const pickVerb = (): string => PICK_VERBS[layoutStore.get()];
